<template>
	<div class="default-input default-input--select" :class="{'default-input--error' : errors.length, 'default-input--required' : required }">
		<span class="default-input__label" v-if="label">{{ label }}</span>
		<div class="default-input__wrapper">
			<div class="default-select" :class="{'default-select--bg' : inputGray }">
				<slot name="select"></slot>
			</div>
		</div>
		<ul v-if="errors.length" class="default-input__errors">
			<li v-for="(error, index) in errors" :key="index">{{ error.$message}}</li>
		</ul>
	</div>
</template>

<script>

export default {
	name: "InputSelect",
	props: {
		required: {
			type: Boolean,
			default: false
		},
		label: {
			type: String,
			default: ''
		},
		errors: {
			type: Array,
			default: () => []
		},
		inputGray: {
			type: Boolean,
			default: false
		},
	},
}
</script>


